import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AppTranslateService } from './core/services/translate.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'madero-reservas';

  constructor(private appTranslateService: AppTranslateService) {}

  ngOnInit(): void { }
}
